import { NO_DATA_PLACEHOLDER, StatusChip, StatusChipVariant } from '@occc-app/design-system';

export type ConnectionStatus = 'online' | 'offline';

type ConnectionStatusChipProps = {
  // Optional until the backend exposes per-store online status (OCST-17349); undefined → "N/A".
  status?: ConnectionStatus;
};

export const ConnectionStatusChip = ({ status }: ConnectionStatusChipProps) => {
  const STATUS_MAP: Record<
    'online' | 'offline' | 'unknown',
    { label: string; variant: StatusChipVariant }
  > = {
    online: { label: 'Online', variant: 'success' },
    offline: { label: 'Offline', variant: 'error' },
    unknown: { label: NO_DATA_PLACEHOLDER, variant: 'default' },
  };

  const { label, variant } = STATUS_MAP[status ?? 'unknown'];
  return <StatusChip label={label} variant={variant} />;
};
